import DashboardsContainer from './containers/DashboardsContainer';

export default DashboardsContainer;
